export const queryKeys = {
    auth: {
        me: ["auth", "me"] as const,
    },
    dashboard: {
        all: ["dashboard"] as const,
        data: () => [...queryKeys.dashboard.all, "data"] as const,
    },
    history: {
        all: ["history"] as const,
        lists: () => [...queryKeys.history.all, "list"] as const,
        list: (limit: number) => [...queryKeys.history.lists(), limit] as const,
    },
    payments: {
        all: ["payments"] as const,
        details: () => [...queryKeys.payments.all, "detail"] as const,
        detail: (id: string) => [...queryKeys.payments.details(), id] as const,
    },
    settings: {
        all: ["settings"] as const,
        customer: () => [...queryKeys.settings.all, "customer"] as const,
    },
    notifications: {
        all: ["notifications"] as const,
        lists: () => [...queryKeys.notifications.all, "list"] as const,
        list: (page: number, unreadOnly: boolean) =>
            [...queryKeys.notifications.lists(), page, unreadOnly] as const,
    },
};
